import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";
import { OnboardingSteps } from './OnboardingSteps';

export class Coworking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
      activeFaq: 0,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response1.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response2.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  toggleFaq = (index) => {
    this.setState(prev => ({ activeFaq: prev.activeFaq === index ? -1 : index }));
  };

  render() {
    const faqs = [
      { q: "❓ Это действительно бесплатно?", a: "Да. Никакой абонентской платы, процентов с броней. Оплата только за SMS и эквайринг (если подключите)." },
      { q: "❓ Как клиент выбирает рабочее место?", a: "Он видит схему этажа, нажимает на стол или переговорную – видит фото, цены, календарь доступности. Можно выбрать место у окна или в тихой зоне." },
      { q: "❓ Можно бронировать на час, день, месяц?", a: "Да. Клиент выбирает период. Система сама рассчитает стоимость. Доступны слоты любой длительности." },
      { q: "❓ Как работает подписка на освобождение?", a: "Если место занято, клиент оставляет контакт и получает уведомление при освобождении." },
      { q: "❓ Нужно ли приложение?", a: "Нет, достаточно браузера. Но есть нативные приложения для iOS и Android." }
    ];

    return (
      <div class="fa-container">
        <Helmet>
          <title>Бронирование рабочих мест и переговорных | CRM для коворкинга — Planna</title>
          <meta name="description" content="Визуальная схема помещений с выбором конкретного стола или комнаты. Клиенты бронируют сами, вы управляете загрузкой. Бесплатно навсегда." />
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"/>
          <link href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,400;14..32,500;14..32,600;14..32,700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
          <script src="{{mainApiUrl}}landing.js"></script>
        </Helmet>
        {/* Hero */}
        <section className="hero">
          <div className="container fade-up">
            <div className="hero-badge">💼 Для коворкингов | Бесплатно навсегда</div>
            <h1>Управляйте бронированием рабочих мест <span className="highlight">визуально и без хлопот</span></h1>
            <p className="hero-description">Схема этажа, выбор конкретного стола или переговорной, бронирование на час/день/месяц. Принимайте заявки онлайн и по телефону. Автоматические напоминания, аналитика загрузки. Всё бесплатно.</p>
            <div className="hero-buttons" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              {!this.state.isAuthenticated ? <a href="/authentication/register" className="btn-filled">Зарегистрироваться <i className="fas fa-arrow-right"></i></a> : <></>}
              <a href="/configcompany" className={this.state.isAuthenticated ? "btn-filled" : "btn-outline"}>Подключить коворкинг бесплатно <i className="fas fa-play"></i></a>
            </div>
          </div>
        </section>

        {/* Преимущества */}
        <section>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Всё для управления пространством</h2>
              <p className="section-subtitle">Принимайте бронирования любым способом и заполняйте коворкинг на 100%</p>
            </div>
            <div className="grid-3 fade-up">
              <div className="benefit-card"><i className="fas fa-couch benefit-icon"></i><h3>Выбор места на схеме</h3><p>Клиент видит план этажа и выбирает конкретный стол или переговорную (у окна, в тихой зоне).</p></div>
              <div className="benefit-card"><i className="fas fa-clock benefit-icon"></i><h3>Бронирование на час/день/месяц</h3><p>Гибкие периоды, автоматический расчёт цены. Подходит для любых форматов работы.</p></div>
              <div className="benefit-card"><i className="fas fa-phone-alt benefit-icon"></i><h3>Брони по телефону — тоже в системе</h3><p>Администратор вносит заявки вручную за 10 секунд. Всё в едином календаре.</p></div>
              <div className="benefit-card"><i className="fas fa-chart-line benefit-icon"></i><h3>Календарь загрузки на месяц</h3><p>Цветовая индикация: зелёные дни – свободно, красные – пик. Клиент выбирает спокойное время.</p></div>
              <div className="benefit-card"><i className="fas fa-bell benefit-icon"></i><h3>Автоматические напоминания</h3><p>SMS, Telegram, push – снижение неявок на 70%.</p></div>
              <div className="benefit-card"><i className="fas fa-qrcode benefit-icon"></i><h3>QR-код для гостей</h3><p>Разместите на ресепшн – бронирование в один клик.</p></div>
            </div>
          </div>
        </section>

        {/* Скриншоты (замените src) */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Как это работает</h2>
              <p className="section-subtitle">Простой и наглядный интерфейс для вас и ваших резидентов</p>
            </div>
            <div className="grid-2 fade-up" style={{ gap: '2.5rem' }}>
              <div className="screenshot-placeholder"><img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Схема+этажа+коворкинга" alt="Схема этажа" /><div className="mockup-label">🗺️ Выбор стола на плане</div></div>
              <div className="screenshot-placeholder"><img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Календарь+загрузки+мест" alt="Календарь загрузки" /><div className="mockup-label">📅 Занятость по дням</div></div>
              <div className="screenshot-placeholder"><img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Бронирование+на+час+или+месяц" alt="Выбор периода" /><div className="mockup-label">⏱️ Выбор длительности</div></div>
              <div className="screenshot-placeholder"><img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Напоминание+резиденту" alt="Напоминание" /><div className="mockup-label">🔔 Напоминание о брони</div></div>
            </div>
          </div>
        </section>

        {/* Умные функции */}
        <section>
          <div className="container">
            {/* Схема этажа */}
            <div className="smart-block fade-up" style={{ marginTop: 0 }}>
              <div style={{ flex: 1 }}>
                <i className="fas fa-draw-polygon" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Выбор рабочего места на схеме</h3>
                <p style={{ margin: '1rem 0', color: '#374151' }}>Клиент видит схему этажа: рабочие столы, переговорные, лаунж-зоны. Свободные места подсвечены. Можно выбрать стол у окна, у розетки, в тихой зоне или переговорную на 4-6 человек. При нажатии — фото, удобства, цена и календарь доступности.</p>
                <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Реальные фото каждого места</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Индивидуальные цены и удобства</li></ul>
              </div>
              <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="https://placehold.co/500x300/F9FAFB/32bea6?text=Схема+этажа" alt="Схема этажа" /><div className="mockup-label">💺 Выберите стол на плане</div></div></div>
            </div>

            {/* Бронирование на час/день/месяц */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem', flexDirection: 'row-reverse' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-hourglass-half" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Гибкая длительность – от часа до месяца</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Клиент сам выбирает период: час, день, неделя, месяц. Система автоматически рассчитывает стоимость. Можно забронировать повторяющиеся слоты (например, каждый вторник с 10 до 14).</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Почасовая оплата</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Скидки при долгосрочной аренде</li></ul>
                </div>
                <div style={{ flex: 0.9 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Выбор+длительности" alt="Выбор длительности" /><div className="mockup-label">⏱️ Час, день, месяц – любой вариант</div></div></div>
            </div>

            {/* Календарь загрузки на месяц */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-calendar-alt" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Календарь загрузки на месяц</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Клиент видит цветовую индикацию занятости коворкинга: зелёные дни – много свободных мест, красные – почти всё занято. Легко выбрать день для комфортной работы.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Равномерное распределение посетителей</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Повышение лояльности</li></ul>
                </div>
                <div style={{ flex: 0.9 }}><div className="screenshot-placeholder"><img src="{{mainApiUrl}}calendar1.png" alt="Календарь загрузки" /><div className="mockup-label">📅 Зелёный – свободно, красный – пик</div></div></div>
            </div>

            {/* Подписка на освобождение */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem', flexDirection: 'row-reverse' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-bell" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Подписка на освободившееся место</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Если любимое место занято, клиент оставляет контакт. Как только кто-то отменит бронь – мгновенное уведомление. Клиент успевает забронировать первым.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Ни одного потерянного резидента</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Автоматическое заполнение отмен</li></ul>
                </div>
                <div style={{ flex: 0.9 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Подписка+на+место" alt="Подписка" /><div className="mockup-label">🔔 Уведомление об освобождении</div></div></div>
            </div>

            {/* Два календаря при бронировании */}
            <div className="smart-block fade-up" style={{ background: 'linear-gradient(110deg, rgba(50,190,166,0.05) 0%, #FFFFFF 100%)', marginTop: '2rem' }}>
                <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Два+календаря" alt="Два календаря" /><div className="mockup-label">📅 Два календаря – один выбор</div></div></div>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-eye" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>При бронировании — два календаря рядом</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Система показывает клиенту его личные события из Google и Apple календаря (только в приложении) и свободные слоты выбранного места. Клиент сразу видит, когда он занят, и выбирает только подходящий период.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Без конфликтов с личными планами</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Удобный выбор времени</li></ul>
                </div>
            </div>
          </div>
        </section>

        {/* Типы пространств */}
        <section style={{ background: '#FEF9F0' }}>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Подходит для любых коворкингов</h2>
            <div className="stats-grid" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1.5rem', marginTop: '2rem' }}>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center' }}><i className="fas fa-chair"></i><h3>Открытые зоны</h3><p>Фиксированные и свободные места</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center' }}><i className="fas fa-door-open"></i><h3>Переговорные</h3><p>Комнаты на 2-10 человек</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center' }}><i className="fas fa-microphone-alt"></i><h3>Лаунж-зоны</h3><p>Места для отдыха и встреч</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center' }}><i className="fas fa-cube"></i><h3>Личные офисы</h3><p>Закрытые кабинеты</p></div>
            </div>
          </div>
        </section>

        {/* Мобильные приложения */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="smart-block fade-up" style={{ background: 'white' }}>
              <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="{{mainApiUrl}}mobile1.png" alt="Мобильное приложение" /><div className="mockup-label">📱 Управляйте коворкингом со смартфона</div></div></div>
              <div style={{ flex: '1.2' }}>
                <i className="fas fa-mobile-alt" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Мобильные приложения для всех</h3>
                <p>Ваши сотрудники и резиденты могут пользоваться сервисом через нативные приложения für iOS и Android.</p>
                <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для коворкинга:</strong> приём броней, управление схемой, уведомления</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для резидентов:</strong> выбор на плане, календарь, подписка на освобождение</li>
                </ul>
                <div className="app-badges" style={{ display: 'flex', justifyContent: 'flex-start', gap: '20px', margin: '20px 0 0 0' }}>
                  <a href="https://apps.apple.com/ru/app/id6773870898" target="_blank"><img src="{{mainApiUrl}}appleru.png" alt="App Store" /></a>
                  <a href="https://play.google.com/store/apps/details?id=com.planna.app" target="_blank"><img src="{{mainApiUrl}}googleru.png" alt="Google Play" /></a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Как это работает за 5 минут</h2>
            <OnboardingSteps
              isRegistered={this.state.isAuthenticated}
              hasCompany={this.state.companies.length > 0}
              hasServices={this.state.services.length > 0}
              hasResources={this.state.resources.length > 0}
              servicesCount={this.state.services.length}
              resourcesCount={this.state.resources.length}
              companyId={this.state.services.length > 0 ? this.state.companies[0].id : 0}
            />
          </div>
        </section>

        {/* FAQ */}
        <section>
          <div className="container fade-up">
            <h2 className="section-title" style={{ textAlign: 'center' }}>Частые вопросы</h2>
            <div style={{ maxWidth: '800px', margin: '2rem auto' }}>
              {faqs.map((faq, idx) => (
                <div key={idx} className={`faq-item ${this.state.activeFaq === idx ? 'active' : ''}`}>
                  <div className="faq-question" onClick={() => this.toggleFaq(idx)}>{faq.q} <i className="fas fa-chevron-down"></i></div>
                  <div className="faq-answer">{faq.a}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section style={{ background: 'linear-gradient(115deg, #1F2937 0%, #32bea6 100%)', color: 'white' }}>
          <div className="container fade-up" style={{ textAlign: 'center', padding: '80px 0' }}>
            <h2 style={{ fontSize: '2.2rem', fontWeight: '800' }}>Начните управлять бронированием рабочих мест сегодня</h2>
            <p style={{ fontSize: '1.1rem', margin: '1rem auto 2rem', maxWidth: '600px', opacity: 0.9 }}>Больше никаких путаниц и потерянных заявок. Ваш коворкинг будет заполнен всегда.</p>
            <a href="/authentication/register" className="btn-filled btn-white">Зарегистрироваться <i className="fas fa-arrow-right"></i></a>
            <a href="/configcompany" className="btn-filled btn-white">Подключить бизнес бесплатно <i className="fas fa-arrow-right"></i></a>
            <p style={{ marginTop: '2rem', fontSize: '0.9rem' }}>Настройка за 15 минут. QR-код, напоминания, аналитика — 0₽</p>
          </div>
        </section>

        {/*
        <h2 class="main2">Как это работает за 5 минут</h2>
        <p class="main3">
          <div class="nowrap">{this.state.isAuthenticated ? <><span class="btndone">Зарегистрироваться</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="authentication/register">Зарегистрироваться</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Зарегистрировать бизнес бесплатно</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configcompany">Зарегистрировать бизнес бесплатно</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить услуги</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configservices">Добавить услуги</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить русурсы</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configresources">Добавить русурсы (рабочие места)</a>}<div class="arrowright"></div></div>
          <div class="nowrap"><a style={{marginLeft: "5px"}} class="btn btn-primary" href="configqrcode">Распечатать QR-код со ссылкой для клиентов</a><div class="arrowright"></div></div>
          <a style={{marginLeft: "5px"}} class="btn btn-primary" href={this.state.companies.length > 0 ? `booking/${this.state.companies[0].id}` : "booking"}>Начать записывать клиентов</a>
        </p>
        */}
      </div>
    );
  }
}
